export class ArticleLoadMoreModule {
    constructor() {

        this.articleLoadMoreButton();
        this.changeFilter();
        this.newToHealthCareFilterChange();
        this.resetFilters();
    }

    resetFilters() {
        $('#article-reset-filter').on("click", function(e) {

            e.preventDefault();
            var button = $(this);
            var listingId = button.attr("data-listing-id");
            var topic = $(".article-filter-topic_" + listingId);
            var content = $(".article-filter-content_" + listingId);
            var location = $(".article-filter-location_" + listingId);

            topic.val("");
            content.val("");
            location.val("");

            var perPage = button.attr("data-article-per-page");
            var parentId = button.attr("data-parent-id");
            var listingWrapper = $("#" + listingId);
            listingWrapper.css({ opacity: 0.3 });

            var url = surfacelocation + "ArticleLoad/LoadNext?take=" + perPage + "&skip=0&parent=" + parentId + "&topic=&content=&location=&uniqueId=" + listingId + "&swapTags=false";

            $.ajax({
                type: "GET",
                url: url,
                processData: false,
                contentType: false
            }).done(function (data) {

                setTimeout(function () {

                    if (data.trim() !== 'none') {
                        listingWrapper.html(data);
                        button.show();

                    } else {
                        listingWrapper.html("");
                    }

                    listingWrapper.css({ opacity: 1 });
                    $(".article-load-more-spinner").hide();
                }, 1500);

            });
        });
    }

    newToHealthCareFilterChange() {

        $('input[type=radio][name=filterNewToPrivateType]').on('change', function() {

            var button = $(this);
            var filterValue = button.val();

            var perPage = $("#perPage").val();
            var listingId = $("#listingId").val();
            var parentId = $("#parentId").val();
            var articleCount = 0;
            var listingWrapper = $("#" + listingId);

            listingWrapper.css({ opacity: 0.3 });

            var url = surfacelocation + "ArticleLoad/LoadPrivateNext?take=" + perPage + "&skip=" + articleCount + "&parent=" + parentId + "&uniqueId=" + listingId + "&filter=" + filterValue;

            $.ajax({
                type: "GET",
                url: url,
                processData: false,
                contentType: false
            }).done(function (data) {

                setTimeout(function () {

                    if (data.trim() !== 'none') {
                        listingWrapper.html(data);
                        button.show();

                    } else {
                        listingWrapper.html("");
                    }

                    listingWrapper.css({ opacity: 1 });
                    $(".article-load-more-spinner").hide();
                }, 1500);

            });
        });
    }

    changeFilter() {
        $('.article-filter-attr').on("change", function(e) {

            var button = $("#article-load-more");
            var listingId = button.attr("data-article-list-id");
            var parentId = button.attr("data-parent-id");
            var topic = $(".article-filter-topic_" + listingId).val();
            var content = $(".article-filter-content_" + listingId).val();
            //var location = $(".article-filter-location_" + listingId).val();
            var location = "";
                        
            var perPage = button.attr("data-article-per-page"); 
          
            button.hide();
            $(".article-load-more-spinner").show();
            var listingWrapper = $("#" + listingId);
            var url = surfacelocation + "ArticleLoad/LoadNext?take=" + perPage + "&skip=" + 0 + "&parent=" + parentId + "&topic=" + topic + "&content=" + content + "&location=" + location + "&uniqueId=" + listingId + "&swapTags=false";

            $.ajax({
                type: "GET",
                url: url,
                processData: false,
                contentType: false
            }).done(function (data) {

                setTimeout(function () {

                    if (data.trim() !== 'none') {
                        listingWrapper.html(data);
                        button.show();

                    } else {
                        listingWrapper.html("");
                    }

                    $(".article-load-more-spinner").hide();
                }, 1500);

            });

        });
    }

    articleLoadMoreButton() {

        $('#article-load-more').on("click", function (e) {

            e.preventDefault();

            var button = $(this);
            var listingId = button.attr("data-article-list-id");
            var topic = $(".article-filter-topic_" + listingId).val();
            var content = $(".article-filter-content_" + listingId).val();
            //var location = $(".article-filter-location_" + listingId).val();
            var location = "";
            var perPage = button.attr("data-article-per-page");
            var totalArticles = button.attr("data-total-articles");
            var parentId = button.attr("data-parent-id");
            var swapTags = button.attr("data-swap-tags");
            var parentDiv = document.getElementsByClassName("article-listing-full-width");

            var childArticlesonPage = $(parentDiv).children().length;

            if (topic === undefined) {
                topic = "";
            }

            if (content === undefined) {
                content = "";
            }

            if (location === undefined) {
                location = "";
            }

            var articleCount = $(".article-item-" + listingId).length;

            button.hide();
            $(".article-load-more-spinner").show();
            var listingWrapper = $("#" + listingId);

            var url = surfacelocation + "ArticleLoad/LoadNext?take=" + perPage + "&skip=" + childArticlesonPage + "&parent=" + parentId + "&topic=" + topic + "&content=" + content + "&location=" + location + "&uniqueId=" + listingId + "&swapTags=" + swapTags;

            $.ajax({
                type: "GET",
                url: url,
                processData: false,
                contentType: false
            }).done(function (data) {

                setTimeout(function () {

                    if (data.trim() !== 'none') {
                        listingWrapper.append(data);
                    }

                    // recount articles to figure out if we've hit the end
                    var newCount = parseInt(articleCount) + parseInt(perPage);
                    var MaxCount = parseInt(childArticlesonPage) + parseInt(perPage);
                    if (totalArticles == MaxCount) {
                        button.hide();
                    }
                    else {
                        button.show();
                    }
                   

                    $(".article-load-more-spinner").hide();
                }, 1500);

            });
        });
    }
}